import { render, staticRenderFns } from "./TravelPlanning.vue?vue&type=template&id=5bfc56ff&"
import script from "./TravelPlanning.vue?vue&type=script&lang=ts&"
export * from "./TravelPlanning.vue?vue&type=script&lang=ts&"
import style0 from "./TravelPlanning.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports